<template>
    <div class="lc_appContainer TQ_font_arial"
         ref="ref_app" @click="m_firstClick_f">

        <!-- splashScreen-->
        <splash-screen :p_whiteLabel_c="store_ongoing_questEvent_vs.val && store_ongoing_questEvent_vs.val.qev_whiteLabel_c"/>

        <!-- body -->
        <global-notification :p_notifications_a="notificationsArr"
                             :style="{direction: co_getDirection_e}"
                             :p_screen-size_en="store_system_windowSizeType_ve.val"
                             :p_system_lang-code_e="store_system_langCode_ve.val"/>

        <!-- browser suggestions -->
        <c_-app_browser-suggestions
            v-if="!co_agentPage_b && co_displayBrowserSuggestions_b && !store_system_continueWithCurrentBrowser_vb.val && !co_isCrawler_b"
            :p_run-in_es="store_system_runIn_ve.val"
            :pe_continue-with-current-browser_f="m_continueWithCurrentBrowser_f"
            :p_system_lang-code_e="store_system_langCode_ve.val"/>

        <!-- main app -->
        <div v-else class="lc_app">

            <!-- -->
            <tq-popup :show="store_ongoing_fullScreenImage_vs" :show-close-btn="true" max-width="max-content" padding="0px">

                <div class="TQ_center TQ_borderBox TQ_maxHeight_bodyFullScreen">
                    <tq-image :pb_src_r="store_ongoing_fullScreenImage_vs.val" class="TQ_maxWidth_100p TQ_maxHeight_bodyFullScreen  TQ_borderBox"/>
                </div>
            </tq-popup>

            <div v-show="!store_ongoing_fullScreenImage_vs.val" >

                <!-- top bar-->
                <div v-if="!co_routeMetadata_o.vrm_hideTopBar_b">
                    <top-bar-web class="lc_appTopBar"
                                 :class="store_system_windowSizeType_ve.val"
                                 :style="{direction: co_getDirection_e, 'zIndex' : gv_zIndex.app_topBar}"
                                 v-if="store_system_windowSizeType_ve.val === enum_windowSizeType.laptop"

                                 :pb_current-user_c="server_currentUserData_c"
                                 :pb_nab-bar-tabs_ac="store_navBar_tabs_vAC.val"
                                 :p_nav-bar_menu_ac="store_navBar_menu_vac.val"

                                 :p_current-score_n="store_ongoing_currentScore_vn.val"
                                 :p_mill-sec-to-end-quest_n="store_ongoing_millSecToEndQuest_vn.val"

                                 :ps_lang-code_e="store_system_langCode_ve.val"
                                 :p_current-currency_e="store_system_currency_ve.val"

                                 :p_back-to_s="co_routeMetadata_o.vrm_backTo_s"
                                 :p_show-back-btn_b="co_routeMetadata_o.vrm_showBackBtn_b"

                                 :p_run-in_e="store_system_runIn_ve.val"

                                 :pe_change-currency_f="m_changeCurrency_f"

                    />
                    <top-bar-mobile v-else
                                    class="lc_appTopBar"
                                    :style="{'zIndex' : gv_zIndex.app_topBar}"
                                    :class="store_system_windowSizeType_ve.val"

                                    :p_nav-bar_menu_ac="store_navBar_menu_vac.val"

                                    :p_network-active_b="networkActive.val"
                                    :p_window-size_e="store_system_windowSizeType_ve.val"
                                    :p_system-lang-code_e="store_system_langCode_ve.val"
                                    :p_current-user-data_c="server_currentUserData_c"
                                    :p_current-currency_e="store_system_currency_ve.val"

                                    :p_back-to_s="co_routeMetadata_o.vrm_backTo_s"
                                    :p_show-back-btn_b="co_routeMetadata_o.vrm_showBackBtn_b"

                                    :p_skips-num_n="store_ongoing_skipsNum_n.val"
                                    :p_clues-num_n="store_ongoing_cluesNum_n.val"
                                    :p_current-score_n="store_ongoing_currentScore_vn.val"
                                    :p_mill-sec-to-end-quest_n="store_ongoing_millSecToEndQuest_vn.val"
                                    :p_run-in_e="store_system_runIn_ve.val"
                                    :p_whiteLabel_c="store_ongoing_questEvent_vs.val && store_ongoing_questEvent_vs.val.qev_whiteLabel_c"

                                    :pe_change-currency_f="m_changeCurrency_f"

                    />
                </div>

                <!-- approve cookies message -->
                <c_-app_-accept-terms-notification
                    :style="{direction: co_getDirection_e, 'zIndex' : gv_zIndex.app_acceptTermsNotification}"
                    class="TQ_bg_purple_lite2 TQ_padding_8px lc_cookiesPolicy TQ_width_100p TQ_borderBox TQ_box_shadow2"
                    :class="co_routeMetadata_o.vrm_hideTopBar_b ? 'lc_cookiesPolicy_top' : 'lc_cookiesPolicy'"
                    v-if="(co_show_acceptCookiesPolicy_b || co_show_acceptTermsOfUse_b) && !co_inTermsRoute_b && !co_inWhiteLabelPath_b"

                    :p_show-cookies-policy_b="co_show_acceptCookiesPolicy_b"
                    :p_show-terms-of-use_b="co_show_acceptTermsOfUse_b"
                    :p_lang-code_e="store_system_langCode_ve.val"

                    :pe_approve-cookies-policy_f="m_acceptCookies_f"
                    :pe_approve-terms-of-use_f="m_acceptTermsOfUse_f"/>

                <!--route view-->
                <router-view
                    class="lc_appBody"
                    :style="{
                        direction       : co_getDirection_e,
                        marginTop       : co_routeMetadata_o.vrm_hideTopBar_b ? '0px'      : mainRoute_paddingTop_s,
                        marginBottom    : co_routeMetadata_o.vrm_hideBottomBar_b ? '0px'   : mainRoute_paddingBottom_s,
                    }"/>

                <!-- bottom bar-->
                <bottom-bar-mobile class="lc_appBottomBar"
                                   :style="{direction: co_getDirection_e, 'zIndex' : gv_zIndex.app_bottomBar}"
                                   v-if="co_showBottomBar_b"
                                   :p_current-user-data_c="server_currentUserData_c"
                                   :p_nab-bar-tabs_ac="store_navBar_tabs_vAC.val"
                                   :p_screen-size_en="store_system_windowSizeType_ve.val"
                                   :p_system_lang-code_e="store_system_langCode_ve.val"/>

                <!-- new version-->
                <app_new-version-app v-if="server_versionInfo_c"
                                     :style="{direction: co_getDirection_e}"
                                     :p_system_lang-code_e="store_system_langCode_ve.val"

                                     :p_server-version-info_c="server_versionInfo_c"

                                     :p_local-web-version_c="local_currentWebVersion_o"
                                     :p_android-info_c="androidInfo_c"
                                     :p_ios-version_s="iosVersion_s"

                                     :p_service-worker-loader_b="store_system_serviceWorkerCacheLoader_b.val"
                                     :p_current-user-data_c="server_currentUserData_c"
                />


            </div>

        </div>

    </div>
</template>

<script >

import {
    store_var,
    store_getStateValue_vo,
    store_setStateValue,
    store_listener_set_f,
    store_listener_remove_f
} from "./store";

import {
    serverAuth_currentUserData_get_vl_fp,
    serverAuth_currentUserData_remove_vl_f, serverAuth_currentUserData_update_f,
} from "./scripts/Server/S_ServerAuth";

import {
    serverGlobal_currentVersion_vl_remove_f,
    serverGlobal_currentVersion_vl_set_f,
} from "./scripts/Server/S_ServerPre";
import {
    enum_costCurrency_n,
    enum_eventsListenersNames, enum_langCodes,
    enum_runIn_es,
} from "../functions/src/shareCode/Share_S_Enum";

import {helper_getDirectionByLangCode_fe, helper_getLangFlagWithLangCode_fr} from "./scripts/S_Helper";

import SplashScreen from "./views/App/C_App_SplashScreen";
import GlobalNotification from "./views/App/C_App_GlobalNotification";
import {notificationsArr} from "./scripts/S_Notification";
import TopBarWeb from "./views/App/C_App_TopBarWeb";
import TopBarMobile from "./views/App/C_App_TopBarMobile";
import BottomBarMobile from "./views/App/C_App_BottomBarMobile";
import {
    date_doEveryClockTick_init_f,
    date_newDate_fd,
    date_setTimeout
} from "./scripts/S_Date";
import {
    eventListener_addEventListenerToObj,
    eventListener_removeEventListenerToObj
} from "./scripts/S_EventListeners";

import currentWebVersion_o from '../currentVersion'
import App_newVersionApp from "./views/App/C_App_NewVersionApp";
import {
    ass_strings,
} from "../functions/src/shareCode/Share_Ass_Dictionary";
import {
    navigator_getOsInfo_fc,
} from "./scripts/S_Navigator";
import {gv_zIndex} from "./scripts/S_GlobalVar";
import Si_finishRiddle from "./components/a_smartIcons/si_finishRiddle";
import {gv_numbers} from "../functions/src/shareCode/Share_Ass_GlobalVariable";
import {enum_moveToOptions, enum_screenSizesOptions_n} from "../functions/src/shareCode/Share_S_Enum";
import {format_costCurrency, format_langCode_fs} from "../functions/src/shareCode/Share_S_Format";

import {
    appWebManager_init_f,
    webAppManager_getVersion_f,
    webAppManager_setKeyboardOnChangeListener_f
} from "./scripts/S_WebAppMediator";
import V_Ongoing_Camera from "./views/v_Ongoing/v_Ongoing_Camera";
import {
    ass_audio_firstLoad, ass_img_closeRed, ass_img_currency_c, ass_img_language, ass_img_logoFull_p
} from "./assets/scripts/Ass_Files";
import C_App_browserSuggestions from "./views/App/C_App_browserSuggestions";
import {route_currentPath2_s, route_getRouteMeta_fo, route_switchLangCode_es} from "./router";
import TqImage from "./components/basic/TqImage";
import TqImgFillBlur from "./components/basic2/TqImgFillBlur";
import TqPopup from "@/components/basic/TqPopup";
import {file_initAudio_f} from "@/scripts/S_Files";
import TqLink from "@/components/basic/TqLink";
import C_App_AcceptTermsNotification from "@/views/App/C_App_AcceptTermsNotification";
import { Cla_ViewRouteMetadata } from "./classes/TqClasses";

export default {
    name: 'App',
    components: {
        C_App_AcceptTermsNotification,
        TqLink,
        TqPopup,
        TqImgFillBlur,
        TqImage,
        C_App_browserSuggestions,
        V_Ongoing_Camera,
        Si_finishRiddle,
        App_newVersionApp,
        BottomBarMobile,
        TopBarMobile,
        TopBarWeb,
        GlobalNotification,
        SplashScreen
    },
    data(){
        return{

            // local
            local_currentWebVersion_o   : currentWebVersion_o,
            androidInfo_c               : null,
            iosVersion_s                : null,

            mainRoute_paddingBottom_s : "0px",
            mainRoute_paddingTop_s : "0px",

            wallSize_n : 20,
            showMaze_b : false,

            // store
            networkActive                               : store_getStateValue_vo(store_var.networkActive),
            store_system_windowSizeType_ve              : store_getStateValue_vo(store_var.system_windowSizeType_e),
            store_system_continueWithCurrentBrowser_vb  : store_getStateValue_vo(store_var.system_continueWithCurrentBrowser_b),
            store_system_langCode_ve                    : store_getStateValue_vo(store_var.system_langCode),
            store_system_currency_ve                    : store_getStateValue_vo(store_var.system_currency),
            store_system_osInfo_vc                      : store_getStateValue_vo(store_var.system_osInfo_c),
            store_system_displayKeyboard_vb             : store_getStateValue_vo(store_var.system_displayKeyboard_b),
            store_system_shortScreen_vb                 : store_getStateValue_vo(store_var.system_shortScreen_b),
            store_system_compassHeading_vc              : store_getStateValue_vo(store_var.system_compassHeading_c),
            store_system_compassHeadingDiff_vByDiffN    : store_getStateValue_vo(store_var.system_compassHeading_offSet_byDiffN),
            store_system_runIn_ve                       : store_getStateValue_vo(store_var.system_runIn_e),
            store_system_approveCookiesPolicyVersion_vs : store_getStateValue_vo(store_var.system_approveCookiesPolicyVersion_s),

            store_navBar_tabs_vAC                       : store_getStateValue_vo(store_var.navBar_tabs_ac),
            store_navBar_menu_vac                       : store_getStateValue_vo(store_var.navBar_menu_ac),
            store_system_serviceWorkerCacheLoader_b     : store_getStateValue_vo(store_var.system_serviceWorkerCacheLoader_b),
            store_ongoing_cluesNum_n                    : store_getStateValue_vo(store_var.ongoing_cluesNum_n),
            store_ongoing_skipsNum_n                    : store_getStateValue_vo(store_var.ongoing_skipsNum_n),
            store_ongoing_currentScore_vn               : store_getStateValue_vo(store_var.ongoing_currentScore_n),
            store_ongoing_millSecToEndQuest_vn          : store_getStateValue_vo(store_var.ongoing_millSecToEndQuest_n),
            store_ongoing_questEvent_vs                 : store_getStateValue_vo(store_var.ongoing_questEvent),
            store_ongoing_fullScreenImage_vs            : store_getStateValue_vo(store_var.ongoing_fullScreenImage_s),

            // server
            server_currentUserData_c : undefined,
            server_versionInfo_c     : undefined,

            // imports
            notificationsArr        : notificationsArr,
            enum_windowSizeType     : enum_screenSizesOptions_n,
            ass_strings             : ass_strings,
            ass_img_logoFull_p      : ass_img_logoFull_p,
            ass_img_language        : ass_img_language,
            ass_img_currency_c      : ass_img_currency_c,
            ass_img_closeRed        : ass_img_closeRed,
            gv_zIndex               : gv_zIndex,
            enum_langCodes          : enum_langCodes,
            enum_costCurrency_n     : enum_costCurrency_n,
            enum_moveToOptions     : enum_moveToOptions,

            format_langCode_fs      : format_langCode_fs,
            format_costCurrency     : format_costCurrency,
            helper_getLangFlagWithLangCode_fr: helper_getLangFlagWithLangCode_fr,
        }
    },
    computed:{

        co_routeMetadata_o(){
            if( this.$route.path === enum_moveToOptions.root){
                return new Cla_ViewRouteMetadata({
                    vrm_hideBottomBar_b: true,
                    vrm_hideTopBar_b: true
                }) 
            }
            return route_getRouteMeta_fo(this.$route)
        },
        co_showBottomBar_b(){
            return !this.store_system_displayKeyboard_vb.val // show keyboard
                && !this.store_system_shortScreen_vb.val // short screen
                && this.store_system_windowSizeType_ve.val !== this.enum_windowSizeType.laptop // laptop
                && !this.co_routeMetadata_o.vrm_hideBottomBar_b // hide from route
                && this.store_navBar_tabs_vAC.val && this.store_navBar_tabs_vAC.val.length > 0
        },
        co_getDirection_e(){
            return helper_getDirectionByLangCode_fe(this.store_system_langCode_ve.val)
        },
        co_agentPage_b(){
            return route_currentPath2_s().includes(enum_moveToOptions.player_store_agent)
        },
        co_displayBrowserSuggestions_b(){
            return [enum_runIn_es.mac_other, enum_runIn_es.ios_web_other, enum_runIn_es.android_web_other, enum_runIn_es.windows_other].includes(this.store_system_runIn_ve.val)
        },
        co_mazeHeight_n(){
            return window.innerHeight / this.wallSize_n
        },
        co_mazeWidth_n(){
            return window.innerWidth / this.wallSize_n
        },
        co_isCrawler_b(){
            return /bot|google|baidu|bing|msn|teoma|slurp|yandex/i
                .test(navigator.userAgent)
        },
        co_inTermsRoute_b(){
            return route_currentPath2_s().includes(enum_moveToOptions.terms)
        },
        co_inWhiteLabelPath_b(){
            let path_s = route_currentPath2_s()

            return path_s.includes(enum_moveToOptions.player_store_whiteLabel)
        },
        co_show_acceptCookiesPolicy_b(){

            if(this.co_isCrawler_b){
                return false
            }

            let path_s = route_currentPath2_s()
            if(path_s.includes(enum_moveToOptions.ongoing) || path_s.includes(enum_moveToOptions.player_play_entry_ticket)){
                return false
            }

            // check approve in DB
            if(this.server_currentUserData_c){
                return this.server_currentUserData_c.ud_approveCooliesPolicyVersion_s < this.local_currentWebVersion_o.cookiesVersion
            }

            // check approve in localStorage
            return this.store_system_approveCookiesPolicyVersion_vs.val < this.local_currentWebVersion_o.cookiesVersion

        },
        co_show_acceptTermsOfUse_b(){

            return this.server_currentUserData_c
                && this.server_currentUserData_c.ud_approveTermsOfUseVersion_s < this.local_currentWebVersion_o.termsOfUseVersion
        }

    },
    methods: {

        m_firstClick_f(){
            file_initAudio_f(ass_audio_firstLoad)
        },
        m_changeCurrency_f(currency_e){

            store_setStateValue(store_var.system_currency, currency_e)

        },
        m_onUpdateScreenSizeDo_f() {
            // set css properties

            // set short screen
            store_setStateValue(store_var.system_shortScreen_b, window.innerHeight < gv_numbers.shortScreenMaxHeight)
            store_setStateValue(store_var.system_screenWidth, window.innerWidth)

            // set screen size
            let topValue_n;
            let bottomValue_n;
            if (window.innerWidth <= gv_numbers.screen_mobile_maxWidth) {
                store_setStateValue(store_var.system_windowSizeType_e, enum_screenSizesOptions_n.mobile)
                topValue_n = 40
                bottomValue_n = 50
            } else if (window.innerWidth <= gv_numbers.screen_table_small_maxWidth) {
                store_setStateValue(store_var.system_windowSizeType_e, enum_screenSizesOptions_n.tablet_small)
                topValue_n = 50
                bottomValue_n = 60
            } else if (window.innerWidth <= gv_numbers.screen_tablet_big_maxWidth) {
                store_setStateValue(store_var.system_windowSizeType_e, enum_screenSizesOptions_n.tablet_big)
                topValue_n = 50
                bottomValue_n = 60
            } else {
                store_setStateValue(store_var.system_windowSizeType_e, enum_screenSizesOptions_n.laptop)
                topValue_n = 58
                bottomValue_n = 0
            }

            // if hide bottom bar
            if (this.store_system_displayKeyboard_vb.val || this.store_system_shortScreen_vb.val) {
                bottomValue_n = 0
            }

            // locally update style
            this.mainRoute_paddingBottom_s = bottomValue_n + "px";
            this.mainRoute_paddingTop_s = topValue_n + "px";

            // globally update style
            if (topValue_n !== document.documentElement.style.getPropertyValue('--topBar')) {
                document.documentElement.style.setProperty('--topBar', topValue_n + "px");
            }

            if (bottomValue_n !== document.documentElement.style.getPropertyValue('--bottomBar')) {
                document.documentElement.style.setProperty('--bottomBar', bottomValue_n + "px");
            }

            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);


        },
        m_acceptCookies_f(){

            let cookiesVersion = this.local_currentWebVersion_o.cookiesVersion

            store_setStateValue(store_var.system_approveCookiesPolicyVersion_s, cookiesVersion)

            if(this.server_currentUserData_c){
                this.server_currentUserData_c.ud_approveCooliesPolicyVersion_s = cookiesVersion
                serverAuth_currentUserData_update_f(this.server_currentUserData_c, () => {})
            }

        },
        m_acceptTermsOfUse_f(){

            if(this.server_currentUserData_c){
                this.server_currentUserData_c.ud_approveTermsOfUseVersion_s = this.local_currentWebVersion_o.termsOfUseVersion
                serverAuth_currentUserData_update_f(this.server_currentUserData_c, () => {})
            }
        },

        // mounted
        m_mounted_getCurrentUserData() {
            serverAuth_currentUserData_get_vl_fp(this.$options.name, (currentUserData) => {
                this.server_currentUserData_c = currentUserData

            })
        },
        m_mounted_getServerCurrentVersion() {

            // get app versions
            webAppManager_getVersion_f((androidInfo_c, iosVersion_s) => {
                this.androidInfo_c = androidInfo_c;
                this.iosVersion_s = iosVersion_s;
            })

            // get server versions
            serverGlobal_currentVersion_vl_set_f(this.$options.name, (versionInfo_c) => {
                this.server_versionInfo_c = versionInfo_c
            });


        },
        m_continueWithCurrentBrowser_f() {
            store_setStateValue(store_var.system_continueWithCurrentBrowser_b, true)
        },
        m_routeWithLang_s(langCode_es){
            return route_switchLangCode_es(this.$route, langCode_es)
        },

    },
    created(){


        // -1) init webappManager
        appWebManager_init_f()

        // 0) get current version
        this.m_mounted_getServerCurrentVersion()

        // 1) current user data
        this.m_mounted_getCurrentUserData()

        // 2) set keyboard status listener
        webAppManager_setKeyboardOnChangeListener_f((keyboardStatus_b) => {


            date_setTimeout(() => {
                store_setStateValue(store_var.system_displayKeyboard_b, keyboardStatus_b)
                this.m_onUpdateScreenSizeDo_f()

            }, 50, this.$options.name)
        })

        // 3) set window size
        eventListener_addEventListenerToObj(window, enum_eventsListenersNames.window_resize, true, this.$options.name, (event) =>{
            this.m_onUpdateScreenSizeDo_f()
        });

        // 4) date_startSystemTimeoutClock
        date_doEveryClockTick_init_f(() =>{
            store_setStateValue(store_var.system_clock_dateTime, date_newDate_fd().getTime(), false)
        });

        // 5) window size listener
        eventListener_addEventListenerToObj(window, enum_eventsListenersNames.windows_load, false, "app.vue", () =>{
            store_setStateValue(store_var.networkActive, navigator.onLine, false)

            // virtual listener
            eventListener_addEventListenerToObj(window, enum_eventsListenersNames.windows_online, false, "app.vue",() => {
                console.log('online')
                store_setStateValue(store_var.networkActive, true , false)
            });

            
            // offline listener
            eventListener_addEventListenerToObj(window, enum_eventsListenersNames.windows_offline, false, "app.vue", () => {
                console.log('offline')
                store_setStateValue(store_var.networkActive, false , false)
            })
        })

        // 6) scroll listener
        let lastUpdateValue_b = undefined
        eventListener_addEventListenerToObj(document, enum_eventsListenersNames.scroll, false, this.$options.name, () =>{
            let scrollToBottom_b = (window.innerHeight + window.scrollY) >= document.body.offsetHeight - gv_numbers.chatSaveDistance

            if(lastUpdateValue_b !== scrollToBottom_b){
                lastUpdateValue_b = scrollToBottom_b
                store_setStateValue(store_var.system_scrollToBottom_b, scrollToBottom_b)
            }
        })

        // 6) onlineUsers
        store_listener_set_f(store_var.system_newSocketDatabaseId_be_s, this.$options.name, (newDatabaseId_s) => {
            // serverAuth_currentUserData_update_f()
            store_listener_remove_f(store_var.system_newSocketDatabaseId_be_s, this.$options.name,)
        })

        // let doEverySecNum_n = 60
        // let counter_n = doEverySecNum_n
        //
        // let doEv
        //
        // doEvery_init_f(id, millscn, doEveryCb_f)
        //
        // date_setTimeout(() => {
        //
        // }, 60 *1000, this.$options.name)
        // date_doEveryClockTick_addCb_f(this.$options.name, () => {
        //
        //     if(counter_n++ >= doEverySecNum_n){
        //         counter_n = 1
        //         if(this.server_currentUserData_c){
        //             serverPre_userDataSub_onlineUsers_update(this.server_currentUserData_c.ud_userId_uid)
        //         }
        //     }
        //
        // }, true)


    },
    mounted(){

        // set osInfo
        store_setStateValue(store_var.system_osInfo_c, navigator_getOsInfo_fc())

    },
    destroyed(){

        // 1) current user data
        serverAuth_currentUserData_remove_vl_f(this.$options.name)
        eventListener_removeEventListenerToObj(window, enum_eventsListenersNames.windows_online)
        eventListener_removeEventListenerToObj(window, enum_eventsListenersNames.windows_offline)

        serverGlobal_currentVersion_vl_remove_f(this.$options.name)
    },
}

</script>


<style lang="scss">

    .lc_cookiesPolicy{
        position: fixed;
        top: var(--topBar);
    }

    .lc_cookiesPolicy_top{
        position: fixed;
        top: 0;
    }

    .lc_fullImage_closeBtn{
        position: absolute;
        top: 0;
        left: 0;
        padding: 8px;
    }

    html {
        width: 100%;
        /*overflow: hidden;*/
        /*position: fixed;*/

        body {
            /*overflow: auto;*/
            /*touch-action: auto;*/
            /*-webkit-overflow-scrolling: touch; !* ios *!*/
            /*height: 100%;*/

            /*position: fixed;*/
            /*overflow: hidden;*/

            /*-webkit-overflow-scrolling: touch;*/

            width: 100%;
            margin: 0;
            padding: 0;

            .lc_appContainer {
                /*height: 100%;*/

                .lc_app {
                    /*height : 100%;*/
                    /*display: grid;*/
                    /*grid-template-rows: auto 1fr auto;*/

                    .lc_appTopBar {
                        box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
                        position: fixed;
                        -webkit-backface-visibility: hidden;

                        top: 0;
                        height: var(--topBar);
                    }

                    .lc_appBody {
                        /*overflow-y: auto;*/
                        /*-webkit-overflow-scrolling: touch;    !* ios *!*/
                    }
                    .lc_appBottomBar {
                        box-shadow: 0 12px 8px 16px rgba(0, 0, 0, 0.2);
                        position: fixed;
                        -webkit-backface-visibility: hidden;
                        bottom: 0;
                        height: var(--bottomBar);


                        .link {
                            color: #4285f4;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }

</style>
